import { LinkButton } from 'components/controls/LinkButton';
import { IVirtualTableColumn } from 'components/layout/VirtualTable/Table/components/VirtualTable';
import { getConcernLevelColor } from 'shared/utils/concern-level.utils';
import { Issue } from '../../../queries/issues-list.queries.types';
import i18next from 'i18next';
import { DateTime } from 'luxon';
import CellContainer from 'components/Shared/CellContainer';

export const getIssueListTableColumns = (
   handleColumnClick: (ev: React.MouseEvent<HTMLElement>, column: IVirtualTableColumn<Issue>) => void,
   handleRowClick: (item: Issue) => void,
): IVirtualTableColumn<Issue>[] => {

   const formatDate = (date?: Date): string => {
      if (!date) return '';

      const dt = DateTime.fromJSDate(date);
      return dt.toLocaleString({...DateTime.DATE_SHORT, weekday: 'short', month: 'short'});
   };

   return [
      {
         key: 'column1',
         name: 'Case ID',
         fieldName: 'observationId',
         minWidth: 40,
         maxWidth: i18next.language == 'gb' ? 30 : 60,
         isResizable: false,
         isSorted: false,
         isSortedDescending: false,
         sortAscendingAriaLabel: 'Sorted A to Z',
         sortDescendingAriaLabel: 'Sorted Z to A',
         onColumnClick: handleColumnClick,
         data: 'string',
         isPadded: true,
         onRender: (item: Issue) => <CellContainer>{item.observationId}</CellContainer>
      },
      {
         key: 'column2',
         name: 'Incident Date',
         fieldName: 'incidentDate',
         minWidth: 110,
         maxWidth: 115,
         isResizable: false,
         isSorted: true,
         isSortedDescending: true,
         sortAscendingAriaLabel: 'Sorted A to Z',
         sortDescendingAriaLabel: 'Sorted Z to A',
         onColumnClick: handleColumnClick,
         data: 'string',
         isPadded: true,
         onRender: (item: Issue) => (
            <CellContainer>
               {formatDate(new Date(item.incidentDate))}
            </CellContainer>
         )
      },
      {
         key: 'column3',
         name: 'Concern Level',
         fieldName: 'concernLevel',
         minWidth: 80,
         maxWidth: i18next.language == 'gb' ? 90 : 145,
         isResizable: false,
         isSorted: false,
         isSortedDescending: false,
         sortAscendingAriaLabel: 'Sorted Low to High',
         sortDescendingAriaLabel: 'Sorted High to Low',
         onColumnClick: handleColumnClick,
         data: 'string',
         isPadded: true,
         onRender: (item: Issue) => (
            <CellContainer style={{ color: getConcernLevelColor(item.concernLevel) }}>
               {item.concernLevel.toProperCase()}
            </CellContainer>
         ),
         sortValueResolver: (item: Issue) => {
            {item.concernLevel.toProperCase()};
         }
      },
      {
         key: 'column4',
         name: 'What Happened',
         fieldName: 'whatHappened',
         minWidth: 50,
         maxWidth: 200,
         isResizable: true,
         isSorted: false,
         isSortedDescending: false,
         sortAscendingAriaLabel: 'Sorted A to Z',
         sortDescendingAriaLabel: 'Sorted Z to A',
         onColumnClick: handleColumnClick,
         data: 'string',
         isPadded: true,
         onRender: (item: Issue) => <CellContainer>{item.whatHappened}</CellContainer>,
         sortValueResolver: (item: Issue) => item.whatHappened
      },
      {
         key: 'column6',
         name: 'Depot',
         fieldName: 'depotPcName',
         minWidth: 80,
         maxWidth: 150,
         isResizable: true,
         isSorted: false,
         isSortedDescending: false,
         sortAscendingAriaLabel: 'Sorted A to Z',
         sortDescendingAriaLabel: 'Sorted Z to A',
         onColumnClick: handleColumnClick,
         data: 'string',
         isPadded: true,
         onRender: (item: Issue) => <CellContainer>{item.depotPcName}</CellContainer>
      },
      {
         key: 'column7',
         name: 'Reach Name',
         fieldName: 'reachName',
         minWidth: 80,
         maxWidth: 110,
         isResizable: false,
         isSorted: false,
         isSortedDescending: false,
         sortAscendingAriaLabel: 'Sorted A to Z',
         sortDescendingAriaLabel: 'Sorted Z to A',
         onColumnClick: handleColumnClick,
         data: 'string',
         isPadded: true,
         onRender: (item: Issue) => (
            <CellContainer>
               {item.reachName}
            </CellContainer>
         )
      },
      {
         key: 'column8',
         name: 'Process Name',
         fieldName: 'processName',
         minWidth: 80,
         maxWidth: 110,
         isResizable: false,
         isSorted: false,
         isSortedDescending: false,
         sortAscendingAriaLabel: 'Sorted A to Z',
         sortDescendingAriaLabel: 'Sorted Z to A',
         onColumnClick: handleColumnClick,
         data: 'string',
         isPadded: true,
         onRender: (item: Issue) => (
            <CellContainer>
               {item.processName}
            </CellContainer>
         )
      },
      {
         key: 'column9',
         name: 'Status',
         fieldName: 'observationStatus',
         minWidth: 60,
         maxWidth: 70,
         isResizable: false,
         isSorted: false,
         isSortedDescending: false,
         sortAscendingAriaLabel: 'Sorted Open first',
         sortDescendingAriaLabel: 'Sorted Open last',
         onColumnClick: handleColumnClick,
         data: 'date',
         isPadded: true,
         onRender: (item: Issue) => (
            <CellContainer>{item.observationStatus.toProperCase()}</CellContainer>
         ),
         sortValueResolver: (item: Issue) => {
            {item.observationStatus.toProperCase()};
         }
      },
      {
         key: 'column10',
         name: '',
         minWidth: 20,
         maxWidth: 20,
         isResizable: false,
         data: 'date',
         isPadded: true,
         onRender: (item: Issue) => (
            <LinkButton
               text={"View"}
               onClick={e => {
                  e.preventDefault();
                  handleRowClick(item);
               }}
            />
         )
      }
   ];
};
